// src/components/ui/Button.jsx
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function Button({
  children,
  className = "",
  loading = false,
  variant = "primary", // primary | secondary | outline | ghost | danger
  size = "md", // sm | md | lg
  icon: Icon = null,
  iconPosition = "left",
  fullWidth = true,
  disabled,
  ...props
}) {
  /* =========================
      VARIANTS (SaaS style)
  ========================= */
  const variants = {
    primary:
      "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-600",
    secondary:
      "bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700 focus:ring-gray-400",
    outline:
      "border border-gray-300 text-gray-900 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-100 dark:hover:bg-gray-800 focus:ring-gray-400",
    ghost:
      "bg-transparent text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800 focus:ring-gray-400",
    danger:
      "bg-red-600 text-white hover:bg-red-700 focus:ring-red-600",
  };

  /* =========================
      SIZES
  ========================= */
  const sizes = {
    sm: "h-9 px-3 text-sm",
    md: "h-11 px-4 text-sm",
    lg: "h-12 px-6 text-base",
  };

  /* =========================
      LOADING ICON
  ========================= */
  const Spinner = () => (
    <ArrowPathIcon className="w-4 h-4 animate-spin" />
  );

  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center gap-2
        rounded-lg font-medium
        transition-all
        focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-900
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? "w-full" : ""}
        ${className}
      `}
    >
      {/* LEFT ICON */}
      {iconPosition === "left" &&
        (loading ? <Spinner /> : Icon && <Icon className="w-4 h-4" />)}

      {/* LABEL */}
      <span className={loading ? "opacity-0" : "opacity-100"}>
        {children}
      </span>

      {/* RIGHT ICON */}
      {iconPosition === "right" &&
        (loading ? <Spinner /> : Icon && <Icon className="w-4 h-4" />)}
    </button>
  );
}
